import React from "react";
import FullScreenLayout from "../../layout/FullScreenLayout";
import { useTranslation } from "hhn-commons";
import { Container, IconButton } from "@mui/material";
import { ModalHeader, ModalHeading } from "./UserSettings.style";
import CloseIcon from "@mui/icons-material/Close";

interface AddPatientModalProps {
  closeModal: () => void;
}

export const AddPatientModal: React.FC<AddPatientModalProps> = ({ closeModal }) => {
  const { t } = useTranslation();
  return (
    <FullScreenLayout>
      <Container data-testid="add-patient">
        <ModalHeader>
          <ModalHeading>{t("notImplemented")}</ModalHeading>
          <IconButton
            size="large"
            color="inherit"
            data-testid="close-add-patient"
            onClick={closeModal}
          >
            <CloseIcon />
          </IconButton>
        </ModalHeader>
      </Container>
    </FullScreenLayout>
  );
};
